<app-desktop
  [menuItems]="menuItems()"
  [temperature]="temperature.value()?.temperature ?? 74"
  class="hidden lg:block"
/>
<app-mobile
  [menuItems]="menuItems()"
  [temperature]="temperature.value()?.temperature ?? 74"
  class="lg:hidden"
/>
